import storageService from './storage'
import { parseDate, formatDate } from '../date_manipulation'

const EDITORIAL_SEARCH_STATUS_KEY = 'searches_status:editorial'

export default {
  saveCalendarDates: (startDate, endDate) => {
    storageService.writeAndMerge(EDITORIAL_SEARCH_STATUS_KEY, {
      startDate: formatDate({ date: startDate }),
      endDate: formatDate({ date: endDate })
    })
  },

  saveSelectedDate: (selectedDate) => {
    storageService.writeAndMerge(EDITORIAL_SEARCH_STATUS_KEY, {
      selectedDate: formatDate({ date: selectedDate })
    })
  },

  read: () => {
    const payload = storageService.read(EDITORIAL_SEARCH_STATUS_KEY)

    if (payload) {
      return {
        ...payload,
        startDate: parseDate({ date: payload.startDate, outputPlugin: false }),
        endDate: parseDate({ date: payload.endDate, outputPlugin: false })
      }
    }
  },

  clear: () => storageService.clear(EDITORIAL_SEARCH_STATUS_KEY),

  expiresIn: () => storageService.expiresIn(EDITORIAL_SEARCH_STATUS_KEY)
}
